import { Input } from "components/hookformcontrol/input/Input";
import React from "react";
import { useForm } from "react-hook-form";
import Styles from "./SectionField.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { setDroppedItems, setToggleCheck } from "redux/slices/formSlice";
import { setUpdateDroppedItems } from "redux/slices/formSlice";
import { setPublish } from "redux/slices/globalSlice";

const SectionField = (props) => {
  const dispatch = useDispatch();
  const { droppedItems, selectedData } = useSelector((state) => state.form);

  // Function to recursively update dependent fields
  const updateField = (item, id, newValue) => {
    if (item.data?.id === id) {
      return { ...item, data: { ...item.data, value: newValue } };
    }

    if (Array.isArray(item.dependentField) && item.dependentField.length > 0) {
      return {
        ...item,
        dependentField: item.dependentField.map((child) =>
          updateField(child, id, newValue)
        ),
      };
    }

    return item;
  };

  const handleInputChange = (e) => {
    const { value } = e.target;

    const updatedItems = droppedItems.map((item) =>
      updateField(item, selectedData?.id, value)
    );

    dispatch(setDroppedItems([...updatedItems])); // Ensure a new state reference
    dispatch(setPublish(true));
  };

  // Find the selected item (either section or child)
  const findSelectedItem = (items, id) => {
    for (let item of items) {
      if (item.id === id) return item;
      if (Array.isArray(item.dependentField) && item.dependentField.length > 0) {
        const found = findSelectedItem(item.dependentField, id);
        if (found) return found;
      }
    }
    return null;
  };

  const selectedItem = findSelectedItem(droppedItems, selectedData?.id);

  const { register, control } = useForm({
    defaultValues: {
      required: selectedItem?.data?.required || false,
    },
  });

  const handleChange = (field, value) => {
    dispatch(
      setToggleCheck({
        sectionId: selectedData?.id,
        value: !value,
      })
    );

    const updatedData = { [field]: value };
    dispatch(setUpdateDroppedItems({ id: selectedData.id, updatedData }));
    dispatch(setPublish(true));
  };


  return (
    <div className={Styles.SectionFieldContainer}>
      <Input
        className={Styles.inputField}
        control={control}
        type="text"
        name="Section"
        value={selectedItem?.data?.value || ""}
        placeholder={props?.placeholder || "Section"}
        onChange={handleInputChange}
      />
      {props?.hideRequired ? null : (
        <div className={Styles.SectionFieldCheckBox}>
          <form
            className={Styles.formContainer}
          >
            <label className={Styles.requiredLabel}>
              <input
                type="checkbox"
                checked={selectedItem?.data?.required || false}
                {...register("required")}
                onChange={(e) => handleChange("required", e.target.checked)}
              />
              {props?.message || "Collapse section by default"}
            </label>
          </form>
        </div>
      )}
    </div>
  );
};

export default SectionField;
